import { IUsuarioLogado } from "@/interfaces/IUsuarioLogado";
import { createAction } from "@reduxjs/toolkit";

const add = createAction("USUARIO_LOGADO/add", (user: IUsuarioLogado) => ({
  payload: { user },
}));

const remove = createAction("USUARIO_LOGADO/remove");

export const usuarioLogadoAction = { add, remove };
